import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface DeleteSubtypeRequest {
  subtype_id: number;
}

export function deleteSubtype(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'DeleteSubtype',
    description: 'Soft-deletes a subtype',
    execute: (data: DeleteSubtypeRequest): Observable<any> => {
      if (!data.subtype_id) {
        return of({ success: false, error: 'Missing required field: subtype_id' });
      }
      return componentDataSourceService.http
        .delete<any>(`${environment.apiUrl}/events/subtypes/${data.subtype_id}`)
        .pipe(
          tap(() => {
            dataSharingService.setData('subtypes_updated', {
              timestamp: Date.now(),
              subtype_id: data.subtype_id,
            });
          }),
          catchError((err) => {
            console.error('[DeleteSubtype] Error:', err);
            throw err;
          })
        );
    },
  };
}
